import React from 'react'
import styled from 'styled-components'
import Button from '../Button/Button'
import { Link } from 'react-router-dom'
import PROJECTS_DATA from '../../projects.data'

const About = () => {

    return (
        <Abt>
            <div>
                <h1>who I am ?</h1>
            </div>
            <Parent>
                <Child>
                    <h1>A few words about me</h1>
                </Child>
                <Child>
                    <p>I'm Mukul Rajpoot, a 3D artist having 2+ years of experience in game development field. I mostly deal with low poly assets for VR, AR games.
                        <br /> What I Offer:
                        <br />👉 Optimised models for Android
                        <br />👉 Models with Lowest possible Triangles
                        <br />👉 Models Suitable for both Unreal and Unity Engines
                        <br />👉 High-Quality 3d model
                        <br />👉 Low weight textures to improve performance
                        <br />👉 Assets will be exported in any format as required
                    </p>
                </Child>
            </Parent>
            <Parent>
                {
                    PROJECTS_DATA.map((project) => (
                        <Link to={`/projects/${project.id}`}>
                            <img src={`/images/${project.id}.png`} alt="" />
                        </Link>
                    ))
                }
            </Parent>
            <Parent style={{ flexDirection: "column" }}>
                <h1>Let's build your Game with Living Models and characters</h1>
                <Link to="/contact">
                    <Button text="Contact me" />
                </Link>
                <Link to="/projects">
                    <Button text="Work" />
                </Link>
            </Parent>
        </Abt>
    )
}

const Abt = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    padding-top: 10vh;

    & > div {
        position: absolute;
        z-index: -1;
        padding: 0 5rem;
        top: 10%;
        left: 15%;

        & > h1 {
            font-weight: 500;
            font-size: 15rem;
            line-height: 13rem;
            color: white;
            -webkit-text-stroke-width: 1px;
            -webkit-text-stroke-color: rgba(0,0,0,0.5);
        }

        @media (max-width: 768px) {
            top: 3%;
            left: 0%;
            & > h1 {
                font-size: 6rem;
            }
        }
    }
`;

const Parent = styled.section`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 2rem 0;
    width: 1280px;
    margin: 0 auto;

    & > h1 {
        font-size: 3rem;
        margin: 2rem 0;
        max-width: 50%;
        text-align: center;
    }

    & > a > img {
        object-fit: cover;
        margin: 2rem;
        width: 50vh;
        height: 30vh;
        border-radius: 20px;
        box-shadow: 2px 3px 10px rgba(0,0,0,0.6);
    }

    & > a {
        text-decoration: none;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        width: 100%;

        /* & > img:last-child, & > img:first-child {
            display: none;
        } */
    }
`;

const Child = styled.section`
    display: flex;
    align-items: center;
    width: 50%;
    padding: 0 5rem;

    @media (max-width: 768px) {
        width: 100%;
    }

    & > h1 {
        font-size: 4rem;
    }

    & > p {
        font-size: 2rem;
    }
`;

export default About
